import React from "react";
import { Sun, Moon, SunMoon, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { WizardMedication } from "@/types/medication";

interface TimeSelectionButtonsProps {
  medication: WizardMedication;
  onChange: (medication: WizardMedication) => void;
}

const TimeButton = ({
  time,
  icon: Icon,
  label,
  isSelected,
  onClick,
}: {
  time: keyof WizardMedication["times"];
  icon: any;
  label: string;
  isSelected: boolean;
  onClick: () => void;
}) => (
  <Button
    type="button"
    variant={isSelected ? "default" : "outline"}
    className="flex flex-col items-center p-8 gap-4 rounded-lg transition-colors duration-30 hover:bg-primary hover:text-white"
    onClick={(e) => {
      e.stopPropagation();
      onClick();
    }}
    onMouseDown={(e) => e.stopPropagation()}
  >
    <Icon className="h-10 w-8" />
    <span className="text-sm">{label}</span>
  </Button>
);

export const TimeSelectionButtons = ({
  medication,
  onChange,
}: TimeSelectionButtonsProps) => {
  return (
    <div className="space-y-2">
      <span className="text-base font-medium">Preferred time of day</span>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        <TimeButton
          time="morning"
          icon={Sun}
          label="Morning"
          isSelected={medication.times?.morning || false}
          onClick={() =>
            onChange({
              ...medication,
              times: {
                ...medication.times,
                morning: !medication.times?.morning,
              },
            })
          }
        />
        <TimeButton
          time="afternoon"
          icon={SunMoon}
          label="Afternoon"
          isSelected={medication.times?.afternoon || false}
          onClick={() =>
            onChange({
              ...medication,
              times: {
                ...medication.times,
                afternoon: !medication.times?.afternoon,
              },
            })
          }
        />
        <TimeButton
          time="evening"
          icon={Clock}
          label="Evening"
          isSelected={medication.times?.evening || false}
          onClick={() =>
            onChange({
              ...medication,
              times: { 
                ...medication.times, 
                evening: !medication.times?.evening 
              },
            })
          }
        />
        <TimeButton
          time="night"
          icon={Moon}
          label="Night"
          isSelected={medication.times?.night || false}
          onClick={() =>
            onChange({
              ...medication,
              times: { 
                ...medication.times, 
                night: !medication.times?.night 
              },
            })
          }
        />
      </div>
    </div>
  );
};